import script from "./custom-pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./custom-pagination.vue?vue&type=script&setup=true&lang=js"

import "./custom-pagination.vue?vue&type=style&index=0&id=5e59e6be&scoped=true&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e59e6be"]])

export default __exports__